export default "../css/0f25a4444d02faac4f606e54f785cc3e.ttf";